export default "__VITE_ASSET__BfUUQtoE__"